import api from './index';

let exports = {};

//生成报价单
exports.savePriceReplyVoucher = function (params, callback) {// 保存报价单
    api.post('/price/reply/save/do')
    .data(params)
    .done(callback)
    .go();
};

//报价列表
exports.getPriceReplyVoucherList = function (params, callback) {// 查询报价列表
    api.post('/price/reply/voucher/list/get')
    .data(params)
    .done(callback)
    .go();
};

//报价申请
exports.applyPriceReplyVoucher = function (params, callback) {// 报价单申请
    api.post('/price/reply/voucher/apply/do')
    .data(params)
    .done(callback)
    .go();
};

//报价审核
exports.auditPriceReplyVoucher = function (params, callback) {// 报价单审核
    api.post('/price/reply/voucher/audit/do')
    .data(params)
    .done(callback)
    .go();
};

//报价呈报
exports.replyPriceReplyVoucher = function (params, callback) {// 报价单呈报
    api.post('/price/reply/voucher/reply/do')
    .data(params)
    .done(callback)
    .go();
};

//商品报价详情
exports.getPriceReplyVoucherInfo = function (params, callback) {// 查询报价详情
    api.post('/price/reply/voucher/info/get')
    .data(params)
    .done(callback)
    .go();
};

//询价列表
exports.getPriceInqryVoucherList = function (params, callback) {// 查询询价列表
    api.post('/price/inqry/voucher/list/get')
    .data(params)
    .done(callback)
    .go();
};

//询价详情
exports.getPriceInqryVoucherInfo = function (params, callback) {// 查询询价详情
    api.post('/price/inqry/voucher/info/get')
    .data(params)
    .done(callback)
    .go();
};

//查询条款信息
exports.getPriceInqryTermList = function (params, callback) {// 查询询价条款信息
    api.post('/price/inqry/term/list/get')
    .data(params)
    .done(callback)
    .go();
};

//查询报价条款信息
exports.getPriceReplyTermList = function (params, callback) {// 查询报价条款信息
    api.post('/price/reply/term/list/get')
    .data(params)
    .done(callback)
    .go();
};

//查询报价条款信息
exports.updatePriceReplyVoucherTag = function (params, callback) {// 修改报价单tag
    api.post('/price/reply/voucher/tag/update/do')
    .data(params)
    .done(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/price.js
// module id = 83
// module chunks = 1